import {ControlUpdater} from '../../dynamic-field/control-updater.type';
import {FieldConfig} from '../../dynamic-field/field.config';
import {isCommonValidatorsChanged, updateCommonFields} from '../../dynamic-field/default-control-updater';
import {buildChipsMultiSelectFieldValidators} from './chips-multiselect-field.builder';

export const chipsMultiSelectFieldControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        setChipsMultiSelectFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity({emitEvent: false});
        return;
    }
    setChipsMultiSelectFieldValidators(currentFieldConfig, updateFieldConfig, control);
};

export const setChipsMultiSelectFieldValidators = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};
    const validators = buildChipsMultiSelectFieldValidators(updatedFieldConfig);
    control.setValidators(validators);
};
